export default function fromBinaryStr(binaryStr: string) {
  // 1: split the binary string into an array of bytes
  const bytes = binaryStr.split('').map((char) => char.charCodeAt(0));
  // 2: create a Uint8Array from the byte data
  const byteArray = new Uint8Array(bytes);
  // 3: decode the byte array into a UTF-16 string
  const decoder = new TextDecoder();
  return decoder.decode(byteArray);
}
